module.exports = __webpack_public_path__ + "img/andrew.d976491a.jpeg";